import { ref, type Ref } from 'vue';
import { defineStore } from 'pinia';
import type { ColorMap } from '../models';
import { useApi } from '../../../services';

export const useColorMapStore = defineStore('colorMapStore', () => {
  const colorMaps: Ref<ColorMap[]> = ref([]);
  const colorMapApi = useApi().colorMap;
  const zoneStrengthColorMap = ref<ColorMap>({} as ColorMap);
  const decisionSupportColorMap = ref<ColorMap>({} as ColorMap);
  const heightmapColorMap = ref<ColorMap>({} as ColorMap);
  const planAttachedWorkDeltaColorMap = ref<ColorMap>({} as ColorMap);

  const HEIGHTMAP_COLOR_MAP_ID = 'b5d2964f-cb54-44fe-a7a8-935924a6d964';
  const DECISION_SUPPORT_COLOR_MAP_ID = 'd1f3e8b3-2f4e-4cd3-3e2f-3c6e5f4b8a3e';
  const PLAN_ATTACHED_WORK_DELTA_COLOR_MAP_ID = 'a1b2c3d4-e5f6-7890-abcd-ef1234567890';

  const loadColorMaps = async () => {
    if (!colorMaps.value.length) {
      const response = await colorMapApi.getColorMap();
      colorMaps.value = response.data;
      setZoneStrengthColorMap();

      const foundedDecisionSupportColorMap = colorMaps.value.find((cMap) => cMap.id === DECISION_SUPPORT_COLOR_MAP_ID);
      if (foundedDecisionSupportColorMap) {
        decisionSupportColorMap.value = foundedDecisionSupportColorMap;
      }

      const foundedHeightmapColorMap = colorMaps.value.find((cMap) => cMap.id === HEIGHTMAP_COLOR_MAP_ID);
      if (foundedHeightmapColorMap) {
        heightmapColorMap.value = foundedHeightmapColorMap;
      }
      const foundedPlanAttachedWorkDeltaColorMap = colorMaps.value.find(
        (cMap) => cMap.id === PLAN_ATTACHED_WORK_DELTA_COLOR_MAP_ID
      );
      if (foundedPlanAttachedWorkDeltaColorMap) {
        planAttachedWorkDeltaColorMap.value = foundedPlanAttachedWorkDeltaColorMap;
      }
    }
  };

  const findColorMap = (colorMapId: string) => {
    return colorMaps.value.find((cMap) => cMap.id === colorMapId);
  };

  const setZoneStrengthColorMap = () => {
    const colorMap = colorMaps.value.find((cMap) => cMap.name === 'zonaero');
    if (colorMap) {
      colorMap.breaks = [50, 100, 120];
      zoneStrengthColorMap.value = colorMap;
    }
  };

  const loadingPromise = loadColorMaps();

  return {
    colorMaps,
    zoneStrengthColorMap,
    decisionSupportColorMap,
    heightmapColorMap,
    loadingPromise,
    planAttachedWorkDeltaColorMap,
    findColorMap
  };
});
